/* eslint-disable import/prefer-default-export */
import api from "./axios";

export const transformQuery = (query) => {
  const queryString = Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join("&");
  if (queryString.length === 0) {
    return "";
  } else {
    return `?${queryString}`;
  }
};

export async function getModels(params) {
  let query = "";
  if (params) {
    query = transformQuery(params);
  }
  const response = await api.get(`/models${query}`);
  return response;
}

export async function getModel(modelId) {
  const response = await api.get(`/models/${modelId}`);
  return response;
}

export async function postModel(model) {
  const response = await api.post("/models", model);
  return response;
}

export async function deleteModel(modelId) {
  const response = await api.delete(`/models/${modelId}`);
  return response;
}

export async function putModel(model, modelId) {
  const response = await api.put(`/models/${modelId}`, model);
  return response;
}
